// 📂 src/api/clientProfileApi.ts
import apiHandler from "../core/apiHandler";

const clientProfileApi = apiHandler("client-profiles");

export default clientProfileApi;
